import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dear-defaults',
  templateUrl: './dear-defaults.component.html',
  styleUrls: ['./dear-defaults.component.scss']
})
export class DearDefaultsComponent implements OnInit {
  @Input() partner;
  @Output() status = new EventEmitter();
  public partnerID;
  public busy = true;
  public config: any = {};
  public registers: any = [];
  public taxes: any = [];
  public users: any = [];
  public locations: any = [];
  public paymentTypes: any = [];
  public isWizard: boolean = false;

  constructor(
    private posIntegrationService: PosIntegrationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private router: Router,
  ) {
    if (this.router.url.indexOf('bikeshop-wizard') > -1) {
      this.isWizard = true;
    }
  }

  ngOnInit() {
    this.partnerID = this.partner.ID || this.partner.PartnerID;
    this.getConfig();
    this.getLocations();
    this.getUsers();
  }


  getConfig() {
    this.posIntegrationService.getConfig(this.partnerID).subscribe(
      (res) => {
        this.config = res;
        console.log(res);
        this.config.Location = res.Location.toString();
        this.config.SalesRep = res.SalesRep.toString();
        this.busy = false;
      },
      (err) => {
        this.busy = false;
      },
    );
    this.busy = false;
  }


  updateConfig() {
    this.busy = true;
    this.config.ID = this.partnerID;

    this.posIntegrationService
      .updateConfig(this.partnerID, this.config)
      .subscribe(
        (result) => {
          this.busy = false;
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant('onboarding.pos_settings_updated'),
          });
          this.status.emit({ configurationSaved: true });
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  getLocations() {
    this.posIntegrationService
      .getLocations(this.partnerID)
      .subscribe((res) => {
        this.busy = false;
        this.locations = res.map((x) => {
          return { label: x.Name, value: x.ExternalKey.toString() };
        });
      });
  }

  getUsers() {
    this.posIntegrationService.getUsers(this.partnerID).subscribe((res) => {
      console.log(res);
      this.users = res.map((x) => {
        return {
          label: x.Firstname + ' ' + x.Surname,
          value: x.POSEmployeeID ? parseInt(x.POSEmployeeID) : null,
        };
      });
    });
  }
}
